const API_BASE = process.env.REACT_APP_API_BASE || 'https://spectra-api.loafstack.dev';

async function asJson(response, action) {
  if (!response.ok) {
    let detail = action;
    try { detail = (await response.json()).detail || action; } catch (e) { /* ignore */ }
    throw new Error(detail);
  }
  return response.json();
}

const adminHeaders = (pass) => ({ 'Content-Type': 'application/json', 'X-Quiz-Admin': pass });

export const quizService = {
  // ---- taker ----
  listQuizzes() {
    return fetch(`${API_BASE}/quizzes`).then((r) => asJson(r, 'Failed to load quizzes'));
  },
  getQuiz(id) {
    return fetch(`${API_BASE}/quizzes/${id}`).then((r) => asJson(r, 'Failed to load quiz'));
  },
  submitAttempt(id, body) {
    return fetch(`${API_BASE}/quizzes/${id}/attempts`, {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body),
    }).then((r) => asJson(r, 'Failed to submit quiz'));
  },
  getMyAttempts(id, takerName) {
    const p = new URLSearchParams({ taker_name: takerName });
    return fetch(`${API_BASE}/quizzes/${id}/attempts?${p}`).then((r) => asJson(r, 'Failed to load attempts'));
  },
  // ---- admin ----
  adminList(pass) {
    return fetch(`${API_BASE}/admin/quizzes`, { headers: adminHeaders(pass) }).then((r) => asJson(r, 'Unauthorized'));
  },
  adminGet(id, pass) {
    return fetch(`${API_BASE}/admin/quizzes/${id}`, { headers: adminHeaders(pass) }).then((r) => asJson(r, 'Failed to load quiz'));
  },
  adminCreate(body, pass) {
    return fetch(`${API_BASE}/admin/quizzes`, { method: 'POST', headers: adminHeaders(pass), body: JSON.stringify(body) }).then((r) => asJson(r, 'Failed to create quiz'));
  },
  adminUpdate(id, body, pass) {
    return fetch(`${API_BASE}/admin/quizzes/${id}`, { method: 'PUT', headers: adminHeaders(pass), body: JSON.stringify(body) }).then((r) => asJson(r, 'Failed to save quiz'));
  },
  adminDelete(id, pass) {
    return fetch(`${API_BASE}/admin/quizzes/${id}`, { method: 'DELETE', headers: adminHeaders(pass) }).then((r) => asJson(r, 'Failed to delete quiz'));
  },
  adminResults(id, pass) {
    return fetch(`${API_BASE}/admin/quizzes/${id}/results`, { headers: adminHeaders(pass) }).then((r) => asJson(r, 'Failed to load results'));
  },
};
